var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tbody',{staticClass:"list"},[_c('tr',[_vm._l((_vm.header),function(head){return [_c('td',{attrs:{"colspan":head.colspan}},[_c('strong',[_vm._v(_vm._s(head.value)+" "+_vm._s(head.after))])])]})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }